/**
 * Created by murat on 8/23/2016.
 */

import {Injectable} from '@angular/core';
import {AppSettings} from '@slarys/ufe-config';
import {ReplaySubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AddressService {

  private dataObs$ = new ReplaySubject(1);
  private hasBeenRequested = false;

  constructor(private httpClient: HttpClient) {
    this.getCities();
  }

  public getCities(forceRefresh?: boolean) {
    // If the Subject was NOT subscribed before OR if forceRefresh is requested
    if (!this.hasBeenRequested || forceRefresh) {
      this.hasBeenRequested = true;
      this.httpClient.get(AppSettings.API_ENDPOINT + '/misc/cities/').subscribe(
          (data) => {
            this.dataObs$.next(data);
          },
          error => {
            this.dataObs$.error(error);
            // Recreate the Observable as after Error we cannot emit data anymore
            this.dataObs$ = new ReplaySubject(1);
          }
      );
    }

    return this.dataObs$;
  }

  // public getCities() {
  //   {
  //     const response: Observable<Array<City>> = this.http.get(AppSettings.API_ENDPOINT + '/cities/')
  //       .pipe(map(res => res.json()));
  //     return response;
  //   }
  // }

  public getTowns(cityLocId) {
    return this.httpClient.get(AppSettings.API_ENDPOINT + '/misc/towns/' + cityLocId);
  }

  public getDistricts(cityLocId, townLocId) {
    {
      return this.httpClient.get(AppSettings.API_ENDPOINT + '/misc/districts/' + cityLocId + '/' + townLocId);
    }
  }

  public getQuarters(cityLocId, townLocId, districtLocId) {
    {
      return this.httpClient.get(AppSettings.API_ENDPOINT + '/misc/quarters/' + cityLocId + '/' + townLocId + '/' + districtLocId);
    }
  }
}
